import { Permission } from '../enums';

// for testing...
type OverrideSetting = 'none' | 'freeform' | 'view-only' | 'producer' | 'content-creator';
const overrideSetting: OverrideSetting = 'none';

const freeformPermissions = [
  Permission.AnalyticsDashboard,
  Permission.Dashboard,
  Permission.Ingest,
  Permission.ListSearchAssets,
  Permission.EditAsset,
  Permission.SubClip,
  Permission.DeleteAsset,
  Permission.DownloadAsset,
  Permission.IngestRetry,
  Permission.EditTagsCategories,
  Permission.StartWithClip,
  Permission.ChannelManager,
  Permission.ListSearchChannels,
  Permission.CreateChannel,
  Permission.EditChannel,
  Permission.DeleteChannel,
  Permission.HaltChannel,
  Permission.DisableChannel,
  Permission.PreviewChannel,
  Permission.EditChannelInfo,
  Permission.EnableAds,
  Permission.EditLiveTransitions,
  Permission.EditLODTransitions,
  Permission.EditLODContent,
  Permission.EditAdsSponsors,
  Permission.ListSearchLivePrograms,
  Permission.CreateLiveProgram,
  Permission.EditLiveProgramInfo,
  Permission.SCTETriggers,
  Permission.GeoFencing,
  Permission.TimeZone,
  Permission.EditProgramLiveTransitions,
  Permission.EditGeoFencing,
  Permission.ListSearchTransitionTemplates,
  Permission.CreateTransitionTemplate,
  Permission.EditTransitionTemplate,
];

const viewOnlyPermissions = [
  Permission.AnalyticsDashboard,
  Permission.Dashboard,
  Permission.ListSearchAssets,
  Permission.ChannelManager,
  Permission.ListSearchChannels,
  Permission.PreviewChannel,
  Permission.ListSearchLivePrograms,
  Permission.ListSearchTransitionTemplates,
];

const producerPermissions = [
  Permission.AnalyticsDashboard,
  Permission.Dashboard,
  Permission.Ingest,
  Permission.ListSearchAssets,
  Permission.EditAsset,
  Permission.SubClip,
  Permission.DeleteAsset,
  Permission.DownloadAsset,
  Permission.IngestRetry,
  Permission.EditTagsCategories,
  Permission.StartWithClip,
  Permission.ChannelManager,
  Permission.ListSearchChannels,
  Permission.CreateChannel,
  Permission.EditChannel,
  Permission.DeleteChannel,
  Permission.HaltChannel,
  Permission.DisableChannel,
  Permission.PreviewChannel,
  Permission.EditChannelInfo,
  Permission.EnableAds,
  Permission.EditLiveTransitions,
  Permission.EditLODTransitions,
  Permission.EditLODContent,
  Permission.EditAdsSponsors,
  Permission.ListSearchLivePrograms,
  Permission.CreateLiveProgram,
  Permission.EditLiveProgramInfo,
  // Permission.SCTETriggers,
  // Permission.GeoFencing,
  // Permission.TimeZone,
  Permission.EditProgramLiveTransitions,
  // Permission.EditGeoFencing,
  Permission.ListSearchTransitionTemplates,
  Permission.CreateTransitionTemplate,
  Permission.EditTransitionTemplate,
];

const contentCreatorPermissions = [
  Permission.AnalyticsDashboard,
  Permission.Dashboard,
  Permission.Ingest,
  Permission.ListSearchAssets,
  Permission.EditAsset,
  Permission.SubClip,
  Permission.DeleteAsset,
  Permission.DownloadAsset,
  Permission.IngestRetry,
  Permission.EditTagsCategories,
  Permission.StartWithClip,
  Permission.ChannelManager,
  Permission.ListSearchChannels,
  // Permission.CreateChannel,
  Permission.EditChannel,
  // Permission.DeleteChannel,
  // Permission.HaltChannel,
  // Permission.DisableChannel,
  Permission.PreviewChannel,
  // Permission.EditChannelInfo,
  // Permission.EnableAds,
  Permission.EditLiveTransitions,
  Permission.EditLODTransitions,
  // Permission.EditLODContent,
  // Permission.EditAdsSponsors,
  Permission.ListSearchLivePrograms,
  // Permission.EditLiveProgramInfo,
  // Permission.SCTETriggers,
  // Permission.GeoFencing,
  // Permission.TimeZone,
  Permission.EditProgramLiveTransitions,
  // Permission.EditGeoFencing,
  Permission.ListSearchTransitionTemplates,
  Permission.CreateTransitionTemplate,
  Permission.EditTransitionTemplate,
];

export class Permissions {
  public lookup: Set<Permission> = new Set();

  constructor(ids: Permission[]) {
    const resolveIds = () => {
      switch (overrideSetting) {
        case 'none':
          return ids;
        case 'freeform':
          return freeformPermissions;
        case 'view-only':
          return viewOnlyPermissions;
        case 'producer':
          return producerPermissions;
        case 'content-creator':
          return contentCreatorPermissions;
      }
    };
    this.lookup = new Set(resolveIds());
  }

  public has(id: Permission): boolean {
    return this.lookup && this.lookup.has(id);
  }
}
